/* eslint-disable @typescript-eslint/ban-types */
import { useEffect, useState } from 'react';
import {
  ResultList,
  ResultListState,
  SearchEngine,
  buildResultList,
  loadAdvancedSearchQueryActions,
  // loadQueryActions,
  loadSearchActions,
  loadSearchAnalyticsActions,
} from '@coveo/headless';
import { RootState } from 'src/store/store';
import { useSelector } from 'react-redux';
import { isEditorActive, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
const FIELDS_TO_INCLUDE: string[] = [
  'trialorgstudyid',
  'trialname',
  'isfeaturedtrial',
  'featuredeprurl',
  'featuredcondition',
  'trialtitle',
  'trialdescription',
  'featuredimage',
  'uri',
];
const useFeatureTrialResultList = (engine: SearchEngine<{}>): any => {
  const userProfile = useSelector((state: RootState) => state.crProfile);
  const { executeSearch } = loadSearchActions(engine);
  const { logInterfaceLoad } = loadSearchAnalyticsActions(engine);
  const [state, setState] = useState<ResultListState>();
  const { sitecoreContext } = useSitecoreContext();
  // const preSelectedConditions = userProfile?.profileData?.conditions;
  const selectedCOI = userProfile?.selectedCOI;
  useEffect(() => {
    if (isEditorActive() || sitecoreContext?.pageState === 'preview') {
      return;
    }
    if (typeof window !== 'undefined' && userProfile) {
      let conditionAdvanceQuery = '';
      const conditionValues = selectedCOI?.map((item: any) => item?.key);
      if (
        conditionValues !== undefined &&
        conditionValues !== null &&
        conditionValues?.length > 0
      ) {
        //const conditionValues = ['Asthma', 'Lung Cancer'];
        let rankModifier = 10;
        // Sort condition values in reverse alphabetical order
        const sortedConditionValues = conditionValues?.sort((a: any, b: any) =>
          b?.localeCompare(a)
        );
        sortedConditionValues?.map((item: any, index: number) => {
          rankModifier = rankModifier + 10000;
          const appendData =
            index === sortedConditionValues?.length - 1
              ? `$qre(expression: @featuredcondition=${item}, modifier: ${rankModifier})`
              : `$qre(expression: @featuredcondition=${item}, modifier: ${rankModifier}) `;
          conditionAdvanceQuery += appendData;
        });
        const searchQueryActionCreators = loadAdvancedSearchQueryActions(engine);
        const advancedSearchQueriesOptions: { aq: string } = {
          aq: conditionAdvanceQuery,
        };
        const searchQueryAction = searchQueryActionCreators.updateAdvancedSearchQueries(
          advancedSearchQueriesOptions
        );
        const resultList: ResultList = buildResultList(engine, {
          options: {
            fieldsToInclude: FIELDS_TO_INCLUDE,
          },
        });
        setState(resultList.state);
        resultList.subscribe(() => {
          setState(resultList.state);
        });
        engine.dispatch(searchQueryAction);
        engine.dispatch(executeSearch(logInterfaceLoad()));
      } else {
        const resultList: ResultList = buildResultList(engine, {
          options: {
            fieldsToInclude: FIELDS_TO_INCLUDE,
          },
        });
        setState(resultList.state);
        resultList.subscribe(() => {
          setState(resultList.state);
        });
        engine.dispatch(executeSearch(logInterfaceLoad()));
      }
    }
    return;
  }, [selectedCOI]);
  return { state };
};
export default useFeatureTrialResultList;
